<script>
import Notification from '../reUse/Notification.vue';
export default {
  components: {
    Notification,
  },
  props: {
    user: Object,
  },
  data() {
    return {
      version: '',
      superUserNotes: [],
      adminNotes: [],
      pilotNotes: [],
      newNote: '',
      selectedLevel: 'super',
      text: '',
      types: '',
      ShowNoti: false,
      loading: false,
      pendingDelete: null,
    }
  },
  mounted() {
    this.GetPatchNotes();
  },
  computed: {
    levelOptions() {
      return [
        {value: 'super', label: 'Super uporabniki', class: 'text-danger'},
        {value: 'admin', label: 'Administratorje', class: 'text-warning'},
        {value: 'pilot', label: 'Pilote', class: 'text-primary'}
      ];
    }
  },
  methods: {
    addNote() {
      if (!this.newNote.trim()) {
        this.showNotification('Vnesite opombo!', 'Napaka');
        return;
      }

      const note = this.newNote.trim();
      const levelMap = {
        'super': 'superUserNotes',
        'admin': 'adminNotes',
        'pilot': 'pilotNotes'
      };
      this[levelMap[this.selectedLevel]].push(note);
      this.newNote = '';
    },

    deleteNote(level, index) {
      this.showNotification('Ali ste prepričani, da želite izbrisati to opombo?', 'Vprašanje');
      this.pendingDelete = {level, index};
    },

    confirmDelete() {
      if (this.pendingDelete) {
        const {level, index} = this.pendingDelete;
        const levelMap = {
          'super': 'superUserNotes',
          'admin': 'adminNotes',
          'pilot': 'pilotNotes'
        };
        this[levelMap[level]].splice(index, 1);
        this.pendingDelete = null;
        this.ShowNoti = false;
      }
    },

    cancelDelete() {
      this.pendingDelete = null;
      this.ShowNoti = false;
    },

    showNotification(message, type) {
      this.text = message;
      this.types = type;
      this.ShowNoti = true;
    },

    getLevelClass(level) {
      const levelMap = {
        'super': 'text-danger',
        'admin': 'text-warning',
        'pilot': 'text-primary'
      };
      return levelMap[level] || '';
    },

    getLevelLabel(level) {
      const levelMap = {
        'super': 'Super uporabnike',
        'admin': 'Administratorje',
        'pilot': 'Pilote'
      };
      return levelMap[level] || '';
    },

    getNotesForLevel(level) {
      const levelMap = {
        'super': 'superUserNotes',
        'admin': 'adminNotes',
        'pilot': 'pilotNotes'
      };
      return this[levelMap[level]] || [];
    },

    savePatchNotes() {
      const podatki = new URLSearchParams();
      podatki.append('version', this.version);
      podatki.append('superUserNotes', JSON.stringify(this.superUserNotes));
      podatki.append('adminNotes', JSON.stringify(this.adminNotes));
      podatki.append('pilotNotes', JSON.stringify(this.pilotNotes));
      axios
          .post("./api/changelog/vnos/", podatki, {withCredentials: true})
          .then((response) => {
            this.showNotification(response.data.sporocilo, 'Uspešno');
          })
          .catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = 'Napaka pri branju podatkov. ' + napaka.response.data.napaka;
            } else {
              this.text = 'Napaka pri branju podatkov.';
            }
            this.types = 'Napaka';
            this.showNotification(napaka.data.sporocilo, 'Napaka');
          })
    },

    GetPatchNotes() {
      axios
          .get("./api/changelog/izpis/")
          .then((response) => {
            this.superUserNotes = response.data.superUserNotes.map(patch => patch.patch);
            this.adminNotes = response.data.adminNotes.map(patch => patch.patch);
            this.pilotNotes = response.data.pilotNotes.map(patch => patch.patch);
            this.version = response.data.version;
          })
          .catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = 'Napaka pri branju podatkov. ' + napaka.response.data.napaka;
            } else {
              this.text = 'Napaka pri branju podatkov.';
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          })
    },
  }
}
</script>
<template>
  <!--         <div class="upper-cloud border-bottom-0 rounded-bottom-4 p-2">
            <button class="p-2 btn-back" @click.prevent="$emit('back')">
                <i class="fas fa-arrow-left fa-2x"></i>
            </button>
            <h4 class="d-flex justify-content-center text-white">Dodaj / Zamenjaj patch notes</h4>
        </div> -->
  <div class="pregled-povrsin-container">
    <!-- Modern Header -->
    <div class="modern-header">
      <div class="header-content">
        <!-- Back Button -->
        <div class="header-section header-left">
          <button class="back-btn" @click.prevent="$router.push('/')">
            <i class="fas fa-arrow-left"></i>
            <span>Nazaj</span>
          </button>
        </div>

        <!-- Title -->
        <div class="header-section header-center">
          <h1 class="page-title">Dodaj / Zamenjaj patch notes</h1>
          <!-- <p class="page-subtitle">Obrazec št. 1 - Poročilo o pregledu površin za gibanje zrakoplovov</p> -->
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid p-3">
    <Transition name="fade">
      <Notification v-if="ShowNoti" :message="text" :type="types" @closeNotification="ShowNoti = false" @da="confirmDelete" @ne="cancelDelete" />
    </Transition>

    <!-- Main Content -->
    <div class="row justify-content-center">
      <div class="col-12 col-lg-10 col-xl-8">
        <!-- Version Input Card -->
        <div class="card modern-card mb-4">
          <div class="card-body p-4">
            <h5 class="card-title text-info mb-3">
              <i class="fas fa-tag me-2"></i>Verzija
            </h5>
            <div class="form-floating">
              <input
                  class="form-control modern-input"
                  type="text"
                  id="version"
                  v-model="version"
                  placeholder="npr. 1.0.0"
                  required
              />
              <label for="version">Verzija (npr. 1.0.0)</label>
            </div>
          </div>
        </div>

        <!-- Add New Note Card -->
        <div class="card modern-card mb-4">
          <div class="card-body p-4">
            <h5 class="card-title text-info mb-4">
              <i class="fas fa-plus-circle me-2"></i>Dodaj novo opombo
            </h5>

            <!-- User Level Selection -->
            <div class="mb-4">
              <label class="form-label text-white mb-3">Izberi nivo uporabnika:</label>
              <div class="btn-group w-100 modern-btn-group" role="group">
                <button
                    v-for="option in levelOptions"
                    :key="option.value"
                    type="button"
                    class="btn modern-level-btn"
                    :class="{ 'active': selectedLevel === option.value }"
                    @click="selectedLevel = option.value"
                >
                  <span :class="option.class">{{ option.label }}</span>
                </button>
              </div>
            </div>

            <!-- Note Input -->
            <div class="mb-4">
              <div class="form-floating">
                                    <textarea
                                        class="form-control modern-textarea"
                                        id="newNote"
                                        v-model="newNote"
                                        rows="6"
                                        placeholder="npr. Vnos/izvoz v podatkovno bazo"
                                        autocomplete="off"
                                        required
                                    ></textarea>
                <label for="newNote">Opomba</label>
              </div>
            </div>

            <!-- Add Note Button -->
            <button
                @click.prevent="addNote"
                class="btn modern-btn-success w-100"
                :disabled="!newNote.trim()"
            >
              <i class="fas fa-plus me-2"></i>
              Dodaj opombo
            </button>
          </div>
        </div>

        <!-- Existing Notes Card -->
        <div class="card modern-card mb-4">
          <div class="card-body p-4">
            <h5 class="card-title text-info mb-4">
              <i class="fas fa-list me-2"></i>Obstoječe opombe
            </h5>

            <!-- Notes Lists -->
            <div class="row">
              <div class="col-12 col-lg-4 mb-4" v-for="level in ['super', 'admin', 'pilot']" :key="level">
                <div class="card level-card h-100">
                  <div class="card-header level-header">
                    <h6 class="card-title mb-0">
                      <i class="fas fa-user me-2"></i>
                      <span :class="getLevelClass(level)">{{ getLevelLabel(level) }}</span>
                    </h6>
                  </div>
                  <div class="card-body p-3">
                    <div v-if="getNotesForLevel(level).length === 0" class="text-muted text-center py-4">
                      <i class="fas fa-info-circle fa-2x mb-2 d-block text-white"></i>
                      <small class="text-white">Ni opomb za ta nivo</small>
                    </div>

                    <div v-else class="notes-list">
                      <div
                          v-for="(note, index) in getNotesForLevel(level)"
                          :key="index"
                          class="note-item"
                      >
                        <div class="d-flex justify-content-between align-items-start">
                          <div class="flex-grow-1">
                            <span class="note-number">{{ index + 1 }}.</span>
                            <span class="note-text">{{ note }}</span>
                          </div>
                          <button
                              class="btn btn-outline-danger btn-sm note-delete-btn"
                              @click="deleteNote(level, index)"
                              title="Izbriši"
                          >
                            <i class="fas fa-trash"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Save Button Card -->
        <div class="card modern-card">
          <div class="card-body p-4 text-center">
            <button
                @click.prevent="savePatchNotes"
                class="btn modern-btn-primary btn-lg px-5"
                :disabled="loading || !version.trim()"
            >
              <i class="fas fa-save me-2"></i>
              Shrani patch notes
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>